import { Suspense, useEffect, useRef, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '@/components/Header'
import PageLoader from '@/components/PageLoader'
import { useScrollReveal } from '@/hooks/useScrollReveal'
import styles from './Layout.module.css'

function SplashGate() {
  useEffect(() => {
    window.__dismissSplash?.()
  }, [])
  return null
}

export default function Layout() {
  const { pathname } = useLocation()
  const initialPath = useRef(pathname)
  const [splashDone, setSplashDone] = useState(false)
  useScrollReveal()

  const isInitialRoute = pathname === initialPath.current && !splashDone

  useEffect(() => {
    if (isInitialRoute) {
      const onRemoved = () => setSplashDone(true)
      const splash = document.getElementById('splash')
      if (!splash) {
        setSplashDone(true)
        return
      }
      const observer = new MutationObserver(() => {
        if (!document.getElementById('splash')) {
          onRemoved()
          observer.disconnect()
        }
      })
      observer.observe(document.body, { childList: true })
      return () => observer.disconnect()
    }
  }, [isInitialRoute])

  return (
    <div className={styles.shell}>
      <Header />
      <main id="main" className={styles.main}>
        <Suspense key={pathname} fallback={isInitialRoute ? null : <PageLoader />}>
          {isInitialRoute && <SplashGate />}
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
